<template>
    <div :class="storeBanner.bannerItem.length ? '' : 'shiftUp'">
        <template v-show="isShow">
            <headline :title="lang($t(headline))" v-show="isShow"></headline>
            <div class="index-promotion-wrapper" v-html="html" v-on:click='handleClick'></div>
        </template>
    </div>
</template>

<script>

    import {common} from "@mixins/common";
    import {storeMapper} from '@mixins/storeMapper';
    import api from '@js/api';
    import EventBus from '@common/eventBus';

    export default {
        name: "NswModule",
        mixins:[common,storeMapper],
        data() {
            return {
                html: "",
                isShow: false,
                headline: "Activities and Promotions"
            };
        },
        mounted()
        {

            this.refreshModule();
            this.listenEvents();
        },
        methods: {
            listenEvents()
            {
                EventBus.$on("refreshModules", ()=>{
                    this.refreshModule();
                });
            },
            handleClick(e) {
                if (e.target.matches('.sso_module_pop_login')) {
                    this.clickModule(e);
                }
            },
            clickModule(event)
            {

                let self = this;
                //not log in
                if (!self.checkIsLoggedIn()) {
                    event.preventDefault();
                    EventBus.$emit("showLogin");
                }
            },
            refreshModule()
            {
                let self = this;

                EventBus.$emit("showGlobalLoading");
                //get html from server
                api.getModule().then(resp=> {

                    if (resp.data.headline) {
                        self.headline = resp.data.headline;
                    }

                    if (resp.data.records.length > 0) {
                        var html = "";

                        resp.data.records.forEach(function(obj) {

                            var classname = "";
                            var aBtn = "<a href='javascript:void(0)'>";

                            //update link if module has file
                            if (obj.file) {

                                //common function
                                var filename = self.getParameterByName('original_filename', obj.file);

                                if (filename) {
                                    obj.link = window.getFileApiByPath+ obj.file+"&filename="+filename;
                                }
                            }

                            if (obj.sso == 0) {

                                if (obj.link) {
                                    aBtn = "<a href='"+obj.link+"' target='"+obj.target+"'>";
                                } else {
                                    classname = "sso_module_pop_login";
                                }

                            } else {
                                if (self.checkIsLoggedIn()) {
                                    aBtn = "<a href='"+obj.link+"' target='"+obj.target+"'>";
                                } else {
                                    classname = "sso_module_pop_login";
                                }
                            }


                            html += "<div>"+ aBtn +
                                "<img class='"+classname+"' src='"+window.getImageApi+obj.image_url+"'></a></div>"
                            ;
                        });

                        self.html = html;

                        self.isShow = true;

                    }

                    EventBus.$emit("hideGlobalLoading");


                }).catch(function (resp) {
                    EventBus.$emit("hideGlobalLoading");
                });
            }
        }

    }
</script>

<style lang="scss">

    //margin of the image
    $gutter:10px;
    $tiny-max: 480; //tiny banner max width
    $small-max: 600; //small banner max width
    $medium-max: 979; //medium banner max width
    $large-max: 1023; //large banner max width


    @mixin tiny($prop...) {
        @media all and (max-width: $tiny-max * 1px) {
            @content;
        }
    }

    @mixin small($prop...) {
        @media all and  (min-width: $tiny-max + 1px) and (max-width: $small-max * 1px) {
            @content;
        }
    }

    @mixin medium($prop...) {
        @media all and (min-width: $small-max + 1px) and (max-width: $medium-max * 1px) {
            @content;
        }
    }

    @mixin large($prop...) {
        @media all and (min-width: $medium-max + 1px) and (max-width: $large-max * 1px) {
            @content;
        }
    }


    @mixin infinity($prop...) {
        @media all and (min-width: $large-max  + 1px) {
            @content;
        }
    }

    @mixin set-width($col-count) {
        flex: 1 0 calc(100%/#{$col-count} - #{$gutter});
        max-width: calc(100%/#{$col-count} - #{$gutter});
    }

    .index-promotion-wrapper{
        display: flex;
        flex-flow: row wrap;
        margin: 0 0 1rem -1 * $gutter;
    }

    .index-promotion-wrapper>div {
        cursor: pointer;
        color: #fff;
        margin: 0 0 $gutter $gutter;
        display:block;
    }

    .shiftUp {
        margin-top:4rem;
    }

    .index-promotion-wrapper>div img{width:100%;max-width:100%;
        -webkit-radius:6px;
        -moz-border-radiust:6px;
        border-radius:6px;
        display:block;
    }

    @include tiny {
        .index-promotion-wrapper>div{
            @include set-width(1);
        }
    }

    @include small {
        .index-promotion-wrapper>div{
            @include set-width(2);
        }
    }


    @include medium {
        .index-promotion-wrapper>div{
            @include set-width(3);
        }
    }

    @include large {
        .index-promotion-wrapper>div{
            @include set-width(4);
        }
    }

    @include infinity {
        .index-promotion-wrapper>div{
            @include set-width(5);
        }
    }

</style>







// WEBPACK FOOTER //
// resources/assets/js/components/NswModule.vue